<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-header">Products</div>
        <div class="card-body">
            <table class="table table-sm">
                <thead>
                    <tr class="text-nowrap">
                        <th scope="col">Name</th>
                        <th class="text-right" scope="col">Price</th>
                        <th class="text-right" scope="col">Deductible</th>
                        <th>Time</th>
                        <th class="text-right" scope="col">Miles</th>
                        <th>Components</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    @for (product of contactWarrantyProducts; track product; let i = $index) {
                        <tr>
                            <td (click)="setInformation(product)">{{product.product.name}}</td>
                            <td (click)="setInformation(product)" class="text-right">{{product.sellingPrice | currency}}</td>
                            <td (click)="setInformation(product)" class="text-right">{{product.deductible | currency}}</td>
                            <td (click)="setInformation(product)">{{product.warrantedTime}}</td>
                            <td (click)="setInformation(product)" class="text-right">{{product.warrantedMiles | number:'1.0-0'}}</td>
                            <td (click)="setInformation(product)">{{product.warrantedComponents}}</td>
                            <td class="actions text-nowrap">
                                <button class="btn-sm btn text-danger" (click)="setId(product.id)" [disabled]="id == product.id" title="Delete" data-toggle="modal" data-target="#deleteProductModal"><span class="dripicons-trash text-danger"></span></button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>

            <form [formGroup]="warrantyInformation">
                <datalist id="corp-products">
                    @for (product of corporateProducts; track product.id) {
                        <option [value]="product.name" data-id="{{product.id}}">{{product.name}}</option>
                    }
                </datalist>
                
                <div class="form-row">
                    <div class="form-group col">
                        <label for="productName">Product Name</label>
                        <input class="form-control form-control-sm" type="search" id="productName" formControlName="productName" list="corp-products" autocomplete="off" />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-lg-4 col-sm-12">
                        <label for="dealerCost">Dealer Cost</label>
                        <currency-input [id]="'dealerCost'" [control]="warrantyInformation.get('dealerCost')"></currency-input>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                        <label for="sellingPrice">Selling Price</label>
                        <currency-input [id]="'sellingPrice'" [control]="warrantyInformation.get('sellingPrice')"></currency-input>
                    </div>
                    <div class="form-group col-lg-4 col-sm-12">
                        <label for="deductible">Deductible</label>
                        <currency-input [id]="'deductible'" [control]="warrantyInformation.get('deductible')"></currency-input>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="contractUsed">Contract Used</label>
                        <input class="form-control form-control-sm" type="text" id="contractUsed" formControlName="contractUsed" autocomplete="off">
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label for="partsPercentage">Parts %</label>
                        <percent-input [id]="'partsPercentage'" [control]="warrantyInformation.get('partsPercentage')"></percent-input>
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label for="laborPercentage">Labor %</label>
                        <percent-input [id]="'laborPercentage'" [control]="warrantyInformation.get('laborPercentage')"></percent-input>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="warrantedTime">Warranted Time</label>
                        <input class="form-control form-control-sm" type="text" id="warrantedTime" placeholder="i.e., 48 months" formControlName="warrantedTime" autocomplete="off">
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="warrantedMiles">Warranted Miles</label>
                        <count-input [id]="'warrantedMiles'" [control]="warrantyInformation.get('warrantedMiles')"></count-input>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="warrantedComponents">Warranted Components</label>
                        <textarea class="form-control form-control-sm" id="warrantedComponents" formControlName="warrantedComponents" lines="3" autocomplete="off"></textarea>
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="buyersObligation">Buyers Obligation</label>
                        <textarea class="form-control form-control-sm" id="buyersObligation" formControlName="buyersObligation" lines="3" autocomplete="off"></textarea>
                    </div>
                </div>
                <div class="float-right mb-1">
                    <button class="btn btn-sm btn-danger mr-1" (click)="resetInformation()">Cancel</button>
                    <button class="btn btn-sm btn-primary" (click)="saveWarranty()" [disabled]="!warrantyInformation.valid || contactId == 0">Save</button>
                </div>
            </form>
        </div>
    </div>
    @if (calledFrom == null) {
    <div class="text-right">
        <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
    </div>
    }
</div>

<!-- modals -->
<!-- delete modal -->
<div class="modal fade" id="deleteProductModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h4 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h4>
                <span class="text-dark my-3 text-center">Are you sure you want to delete this product?</span>
                <button class="btn btn-danger mt-2" (click)="deleteWarranty()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete-product">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
